import * as chatTypes from 'modules/chat/actionTypes';
import * as actionTypes from 'modules/interventions/actionTypes';
import { uniq } from 'utils/ObjectUtils';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {Record<string, string[]>} InterventionMessageIdsReducer */

const initialState = {};

const fetchMessagesSuccess = (state, action) => {
  const newState = { ...state };
  action.payload.content.forEach(message => {
    const entityId = message.partsInterventionId ?? message.interventionId;
    if (entityId) {
      const currentIds = newState[entityId] ?? [];
      newState[entityId] = uniq([...currentIds, message.id]);
    }
  });
  return newState;
};

const receiveMessage = (state, action) => {
  const message = action.payload?.message ?? action.payload;
  const entityId = message.partsInterventionId ?? message.interventionId;

  if (entityId) {
    const { id: messageId } = message;
    const messageIds = state[entityId] ?? [];
    return {
      ...state,
      [entityId]: uniq([messageId, ...messageIds]),
    };
  }
  return state;
};

const deleteIntervention = (state, action) => {
  const { interventionId } = action.payload;
  const { [interventionId]: removed, ...rest } = state;
  return rest;
};

export default createReducer(initialState, {
  [chatTypes.POST_MESSAGE_SUCCESS]: receiveMessage,
  [chatTypes.RECEIVE_MESSAGE_FROM_SOCKET]: receiveMessage,
  [chatTypes.FETCH_MESSAGES_SUCCESS]: fetchMessagesSuccess,
  [actionTypes.DELETE_INTERVENTION_SUCCESS]: deleteIntervention,
});
